import { render, staticRenderFns } from "./List-Package-Online.vue?vue&type=template&id=0d20011a&scoped=true"
import script from "./List-Package-Online.vue?vue&type=script&lang=js"
export * from "./List-Package-Online.vue?vue&type=script&lang=js"
import style0 from "./List-Package-Online.vue?vue&type=style&index=0&id=0d20011a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20011a",
  null
  
)

export default component.exports